import { motion, AnimatePresence } from "framer-motion";

function MapDrawerBase({ isOpen, onClose, children }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          exit={{ x: "100%" }}
          transition={{ type: "tween", duration: 0.3 }}
          className="absolute right-0 top-0 z-[998] flex h-full min-h-0 w-80 flex-col bg-black/50 p-4 text-white backdrop-blur-sm"
        >
          <button
            type="button"
            onClick={onClose}
            className="absolute right-2 top-2 text-lg font-bold text-white"
          >
            ×
          </button>

          <div className="mt-4 flex-1 space-y-2 overflow-y-auto pr-2">
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default MapDrawerBase;
